import { Component, HostBinding, Input } from '@angular/core';
import { iLoanAdvanceApprovalHistory } from 'src/app/helpers/Interfaces/loans-advances';

@Component({
  selector: 'app-loan-status-popover',
  templateUrl: './loan-status-popover.component.html',
  styleUrls: ['./loan-status-popover.component.scss']
})
export class LoanStatusPopoverComponent {
  @HostBinding('class.loan-status-popover') hasClass = true;

  /** Full approval trail */
  @Input() statusList: iLoanAdvanceApprovalHistory[] = [];

  /** Current or latest status */
  @Input() currentLevel?: iLoanAdvanceApprovalHistory;

  statuses = [
    { status: 0, label: 'Pending', color: '#ffe715' },
    { status: 1, label: 'Approved', color: '#4caf50' },
    { status: 2, label: 'Rejected', color: '#f22112' },
  ];
}